<template lang="pug">
v-container(fluid class=" fill-height pa-0 ma-0")
  component(:is="'kubiqa-website-themes-' + theme + '-' + page" class="pa-0 ma-0")
</template>
<script>
export default {
  computed: {
    theme() {
      return this.$store.getters['website/theme'];
    },
    page() {
      return this.$route.name;
    },
  },
};
</script>
